/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSubmissionPayloadDto,
  ErrorResponse,
  FilterSubmissionStatsQueryDto,
  FilterSubmissionStatsResponseDto,
  FilterSubmissionsQueryDto,
  SubmissionCheckResponseDto,
  SubmissionDuplicationCheckPayloadDto,
  SubmissionPaginationResponseDto,
  SubmissionResponseDto,
  UpdateSubmissionPayloadDto,
  UpdateSubmissionStatusPayloadDto,
} from '../models/index';
import {
    CreateSubmissionPayloadDtoFromJSON,
    CreateSubmissionPayloadDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterSubmissionStatsQueryDtoFromJSON,
    FilterSubmissionStatsQueryDtoToJSON,
    FilterSubmissionStatsResponseDtoFromJSON,
    FilterSubmissionStatsResponseDtoToJSON,
    FilterSubmissionsQueryDtoFromJSON,
    FilterSubmissionsQueryDtoToJSON,
    SubmissionCheckResponseDtoFromJSON,
    SubmissionCheckResponseDtoToJSON,
    SubmissionDuplicationCheckPayloadDtoFromJSON,
    SubmissionDuplicationCheckPayloadDtoToJSON,
    SubmissionPaginationResponseDtoFromJSON,
    SubmissionPaginationResponseDtoToJSON,
    SubmissionResponseDtoFromJSON,
    SubmissionResponseDtoToJSON,
    UpdateSubmissionPayloadDtoFromJSON,
    UpdateSubmissionPayloadDtoToJSON,
    UpdateSubmissionStatusPayloadDtoFromJSON,
    UpdateSubmissionStatusPayloadDtoToJSON,
} from '../models/index';

export interface CheckDuplicatedSubmissionRequest {
    submissionDuplicationCheckPayloadDto: SubmissionDuplicationCheckPayloadDto;
}

export interface CreateSubmissionRequest {
    createSubmissionPayloadDto: CreateSubmissionPayloadDto;
}

export interface FilterSubmissionStatsRequest {
    filterSubmissionStatsQueryDto: Array<FilterSubmissionStatsQueryDto>;
}

export interface FilterSubmissionsRequest {
    filterSubmissionsQueryDto: FilterSubmissionsQueryDto;
    field?: FilterSubmissionsFieldEnum;
    order?: FilterSubmissionsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface FindSubmissionByIdRequest {
    submissionId: string;
    includeLayers?: boolean;
    includeInsured?: boolean;
    includeUnderwriter?: boolean;
    prefetchChangelogs?: number;
    includeFiles?: boolean;
}

export interface UpdateSubmissionRequest {
    submissionId: string;
    updateSubmissionPayloadDto: UpdateSubmissionPayloadDto;
}

export interface UpdateSubmissionStatusRequest {
    submissionId: string;
    updateSubmissionStatusPayloadDto: UpdateSubmissionStatusPayloadDto;
}

/**
 * 
 */
export class SubmissionApi extends runtime.BaseAPI {

    /**
     * Check duplicated submission
     */
    async checkDuplicatedSubmissionRaw(requestParameters: CheckDuplicatedSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionCheckResponseDto>> {
        if (requestParameters['submissionDuplicationCheckPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'submissionDuplicationCheckPayloadDto',
                'Required parameter "submissionDuplicationCheckPayloadDto" was null or undefined when calling checkDuplicatedSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/duplicated-check`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmissionDuplicationCheckPayloadDtoToJSON(requestParameters['submissionDuplicationCheckPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionCheckResponseDtoFromJSON(jsonValue));
    }

    /**
     * Check duplicated submission
     */
    async checkDuplicatedSubmission(requestParameters: CheckDuplicatedSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionCheckResponseDto> {
        const response = await this.checkDuplicatedSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create submission
     */
    async createSubmissionRaw(requestParameters: CreateSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResponseDto>> {
        if (requestParameters['createSubmissionPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'createSubmissionPayloadDto',
                'Required parameter "createSubmissionPayloadDto" was null or undefined when calling createSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSubmissionPayloadDtoToJSON(requestParameters['createSubmissionPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create submission
     */
    async createSubmission(requestParameters: CreateSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResponseDto> {
        const response = await this.createSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get submission stats
     */
    async filterSubmissionStatsRaw(requestParameters: FilterSubmissionStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterSubmissionStatsResponseDto>>> {
        if (requestParameters['filterSubmissionStatsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterSubmissionStatsQueryDto',
                'Required parameter "filterSubmissionStatsQueryDto" was null or undefined when calling filterSubmissionStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/filter-stats`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['filterSubmissionStatsQueryDto']!.map(FilterSubmissionStatsQueryDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterSubmissionStatsResponseDtoFromJSON));
    }

    /**
     * Get submission stats
     */
    async filterSubmissionStats(requestParameters: FilterSubmissionStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterSubmissionStatsResponseDto>> {
        const response = await this.filterSubmissionStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Filter submissions
     */
    async filterSubmissionsRaw(requestParameters: FilterSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionPaginationResponseDto>> {
        if (requestParameters['filterSubmissionsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'filterSubmissionsQueryDto',
                'Required parameter "filterSubmissionsQueryDto" was null or undefined when calling filterSubmissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FilterSubmissionsQueryDtoToJSON(requestParameters['filterSubmissionsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter submissions
     */
    async filterSubmissions(requestParameters: FilterSubmissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionPaginationResponseDto> {
        const response = await this.filterSubmissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find submission by id
     */
    async findSubmissionByIdRaw(requestParameters: FindSubmissionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResponseDto>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling findSubmissionById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeLayers'] != null) {
            queryParameters['includeLayers'] = requestParameters['includeLayers'];
        }

        if (requestParameters['includeInsured'] != null) {
            queryParameters['includeInsured'] = requestParameters['includeInsured'];
        }

        if (requestParameters['includeUnderwriter'] != null) {
            queryParameters['includeUnderwriter'] = requestParameters['includeUnderwriter'];
        }

        if (requestParameters['prefetchChangelogs'] != null) {
            queryParameters['prefetchChangelogs'] = requestParameters['prefetchChangelogs'];
        }

        if (requestParameters['includeFiles'] != null) {
            queryParameters['includeFiles'] = requestParameters['includeFiles'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Find submission by id
     */
    async findSubmissionById(requestParameters: FindSubmissionByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResponseDto> {
        const response = await this.findSubmissionByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update submission
     */
    async updateSubmissionRaw(requestParameters: UpdateSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResponseDto>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateSubmission().'
            );
        }

        if (requestParameters['updateSubmissionPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubmissionPayloadDto',
                'Required parameter "updateSubmissionPayloadDto" was null or undefined when calling updateSubmission().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubmissionPayloadDtoToJSON(requestParameters['updateSubmissionPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update submission
     */
    async updateSubmission(requestParameters: UpdateSubmissionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResponseDto> {
        const response = await this.updateSubmissionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update submission status
     */
    async updateSubmissionStatusRaw(requestParameters: UpdateSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmissionResponseDto>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateSubmissionStatus().'
            );
        }

        if (requestParameters['updateSubmissionStatusPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateSubmissionStatusPayloadDto',
                'Required parameter "updateSubmissionStatusPayloadDto" was null or undefined when calling updateSubmissionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/submission/{submissionId}/update-status`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSubmissionStatusPayloadDtoToJSON(requestParameters['updateSubmissionStatusPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmissionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update submission status
     */
    async updateSubmissionStatus(requestParameters: UpdateSubmissionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmissionResponseDto> {
        const response = await this.updateSubmissionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterSubmissionsFieldEnum = {
    Insured: 'insured',
    TransactionType: 'transactionType',
    Underwriter: 'underwriter',
    SubmissionStatus: 'submissionStatus'
} as const;
export type FilterSubmissionsFieldEnum = typeof FilterSubmissionsFieldEnum[keyof typeof FilterSubmissionsFieldEnum];
/**
 * @export
 */
export const FilterSubmissionsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterSubmissionsOrderEnum = typeof FilterSubmissionsOrderEnum[keyof typeof FilterSubmissionsOrderEnum];
